export const logic = {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Function,
      default: () => {}
    },
    term: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleCancel() {
      this.$emit('update:show', false)
    },
    handleOk() {
      const res = this.confirm()
      if (res instanceof Promise) {
        return res.then(() => {
          this.$emit('update:show', false)
        })
      } else {
        this.$emit('update:show', false)
      }
    }
  }
}
